import React, { useEffect, useState } from "react";

import {
  Grid,
  Card,
  CardContent,
  Typography,
  Divider,
  CardMedia,
  styled,
} from "@mui/material";
import PhoneIcon from "@material-ui/icons/Phone";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { Link } from "react-router-dom";
import appointmentsLogo from "assets/appointment-icon-big.png";
import DividerWithText from "components/DividerWithText";
import TodaysAppointmentList from "components/TodaysAppointmentList";
import { useUserData } from "components/customHooks/userDataContext";
import DateTabs from "components/DateTab";
import { StatusCircle, displayDateFormatter } from "components/helpers";
import { getAppointmentCount } from "apiHandler/actions/dashboard";
import useUpdateEffect from "components/customHooks/useUpdateEffect";
import dayjs from "dayjs";

const Container = styled(Grid)(({ theme }) => ({
  display: "flex",
  margin: "0 auto",
  width: "90%",
  maxWidth: theme.spacing(150),
  paddingBottom: theme.spacing(2.5),
}));

const CardContainer = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  marginTop: theme.spacing(0.25),
}));

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: theme.spacing(3.12),
  margin: theme.spacing(1.87),
}));

const BorderCard = styled(Card)(({ theme }) => ({
  borderRadius: theme.spacing(1.25),
}));

const ProviderImage = styled(CardMedia)(({ theme }) => ({
  width: "55%",
  borderRadius: theme.spacing(12.5),
  margin: "auto",
  padding: theme.spacing(1.25),
}));

const ProviderName = styled(Typography)(() => ({
  textTransform: "capitalize",
  textAlign: "center",
}));

const StyledLink = styled(Link)(() => ({
  "&:hover": {
    textDecoration: "none",
  },
}));

const Aptlogo = styled("img")(({ theme }) => ({
  width: theme.spacing(3.75),
  height: theme.spacing(2.5),
  margin: "0px 5px 5px 0px",
}));

const CountDisplay = styled("div")(({ theme }) => ({
  fontSize: theme.spacing(4.6),
}));

const BorderLine = styled("div")(() => ({
  marginLeft: "7%",
}));

function Dashboard() {
  const [appntCount, setAppntCount] = useState({});
  const [duration, setDuration] = useState("WEEK");
  const [dateRange, setDateRange] = useState({
    startDate: dayjs().startOf("week"),
    endDate: dayjs().startOf("week").add(6, "day"),
  });
  const userData = useUserData();
  const token = userData?.access_token;

  useUpdateEffect(() => {
    let start = dateRange.startDate;
    let end = dateRange.endDate;
    if (duration === "DAY") {
      end = start;
    } else if (duration === "WEEK") {
      start = dayjs(start).startOf("week");
      end = dayjs(start).startOf("week").add(6, "day");
    } else if (duration === "WORK WEEK") {
      start = dayjs(start).startOf("week").add(1, "day");
      end = dayjs(start).startOf("week").add(5, "day");
    }
    setDateRange({
      startDate: start,
      endDate: end,
    });
  }, [duration]);

  useEffect(() => {
    fetchAppntCount();
  }, [dateRange]);

  const fetchAppntCount = async () => {
    if (!userData && !userData.doctorData) return;
    const { startDate, endDate } = dateRange;
    const payload = {
      search_criteria: {
        practice_id: userData.selected_practice,
        start_dos: displayDateFormatter(startDate),
        end_dos: displayDateFormatter(endDate),
      },
    };
    const response = await getAppointmentCount(payload, token);
    await setAppntCount(response);
  };

  // const getStartEndTime = () => {
  //   const { startDate, endDate } = dateRange;
  //   return {
  //     startDateTime: `${startDate.getFullYear()}-${startDate.getMonth() + 1
  //       }-${startDate.getDate()}T00:00:00+0000`,
  //     endDateTime: `${endDate.getFullYear()}-${endDate.getMonth() + 1
  //       }-${endDate.getDate()}T23:59:59+0000`,
  //   };
  // };

  const onDateChange = (type) => {
    let start = dayjs(dateRange.startDate);
    let end = dayjs(dateRange.endDate);

    if (type === "add") {
      if (duration === "DAY") {
        start = start.add(1, "day");
        end = start;
      } else if (duration === "WEEK") {
        start = start.add(7, "day");
        end = end.add(7, "day");
      } else if (duration === "WORK WEEK") {
        start = start.add(7, "day");
        end = end.add(7, "day");
      }
    } else if (type === "subtract") {
      if (duration === "DAY") {
        start = start.subtract(1, "day");
        end = start;
      } else if (duration === "WEEK") {
        start = start.subtract(7, "day");
        end = end.subtract(7, "day");
      } else if (duration === "WORK WEEK") {
        start = start.subtract(7, "day");
        end = end.subtract(7, "day");
      }
    }

    setDateRange({
      startDate: start.toDate(),
      endDate: end.toDate(),
    });
  };

  const { doctorData = {} } = userData;
  return (
    <Container container>
      <Grid item xs={12}>
        {userData.doctorData && (
          <StyledCard>
            <ProviderImage
              component="img"
              alt="Contemplative Reptile"
              image={doctorData.providerImage}
              title="Contemplative Reptile"
            />
            <CardContent>
              <ProviderName color="textSecondary" gutterBottom>
                {doctorData.firstName} {doctorData.lastName}{" "}
                <ArrowDropDownIcon fontSize="large" />
              </ProviderName>
              <ProviderName color="textSecondary" gutterBottom>
                <PhoneIcon size="small" /> {doctorData.phone}
              </ProviderName>
            </CardContent>
          </StyledCard>
        )}
      </Grid>

      <Grid item xs={12}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            margin: "5px 0px 2px 2px",
            alignItems: "center",
            height: 30,
          }}
        >
          <div style={{ fontSize: "15px", fontWeight: 401, color: "#333" }}>
            <Aptlogo src={appointmentsLogo} alt="" /> APPOINTMENTS
          </div>
          <div>
            <StyledLink to="/calendar">
              <span style={{ color: "#cc3366", fontWeight: "bold" }}>
                {" "}
                View Calendar
              </span>
            </StyledLink>
            <StyledLink to="/appointments">
              <span
                style={{
                  marginLeft: "15px",
                  color: "#cc3366",
                  fontWeight: "bold",
                }}
              >
                {" "}
                View List
              </span>
            </StyledLink>
          </div>
        </div>
        <BorderCard>
          <CardContent>
            <DateTabs
              duration={duration}
              dateRange={dateRange}
              setDuration={setDuration}
              onDateChange={onDateChange}
              setDateRange={setDateRange}
            />
            <CardContainer
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={3}
            >
              <Grid item xs>
                <StatusCircle offlineType={true} />
                OFF LINE
                <CountDisplay>
                  {appntCount?.selectedDateCount?.offlineCount || 0}
                </CountDisplay>
              </Grid>
              <Divider orientation="vertical" flexItem />
              <Grid item xs>
                <StatusCircle status="confirmed" />
                CONFIRMED
                <CountDisplay>
                  {appntCount?.selectedDateCount?.confirmedCount || 0}
                </CountDisplay>
              </Grid>
              <Divider orientation="vertical" flexItem />
              <Grid item xs>
                <StatusCircle status="waiting" />
                WAITING LIST
                <CountDisplay>
                  {appntCount?.selectedDateCount?.waitingListCount || 0}
                </CountDisplay>
              </Grid>
              <Divider orientation="vertical" flexItem />
              <Grid item xs>
                <StatusCircle status="cancellationrequest" />
                CANCELLATION
                <CountDisplay>
                  {appntCount?.selectedDateCount?.cancellationCount || 0}
                </CountDisplay>
              </Grid>
            </CardContainer>
          </CardContent>
        </BorderCard>
        <BorderLine>
          <DividerWithText>
            <span style={{ color: "#cc3366" }}>Today</span>{" "}
            {dayjs(new Date()).format("DD MMM YYYY")}
          </DividerWithText>
        </BorderLine>
        <TodaysAppointmentList count={appntCount} />
      </Grid>
    </Container>
  );
}

export default Dashboard;
